import React from 'react'
import GlobalContextProvider from './src/components/context/index'

export const wrapRootElement = ({ element }) => {
    return <GlobalContextProvider>{element}</GlobalContextProvider>
}